import { caption, captionStrong } from '../../styles/commonStyles';
import Divider from './divider';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import React from 'react';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'inline-flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			gap: '0.25rem'
		},
		title: {
			wordBreak: 'break-word',
			display: 'inline',
			marginRight: '0.25rem',
			...captionStrong
		},
		value: {
			wordBreak: 'break-word',
			display: 'inline',
			marginRight: '0.25rem',
			...caption
		},
		manyItems: {
			display: 'inline-flex',
			flexDirection: 'row',
			flexWrap: 'wrap'
		},
		rowItem: {
			alignSelf: 'stretch'
		}
	})
);

export interface IDocumentDetailsItem {
	title: string;
	value: React.ReactNode | string;
	linkValue?: boolean;
	testId?: string;
	controlledBy?: string;
}

export interface IDocumentDetailsRowProps {
	items: IDocumentDetailsItem[] | IDocumentDetailsItem;
}

export interface IDocumentDetailsRowStyles {
	rowRootClass?: string;
	rowItemClass?: string;
	titleClass?: string;
	valueClass?: string;
	useHtml?: boolean;
}

const DocumentDetailsRow: React.FunctionComponent<IDocumentDetailsRowProps & IDocumentDetailsRowStyles> = props => {
	const classes = useStyles();
	const items = Array.isArray(props.items) ? props.items : [props.items];
	const manyItems = items.length > 1;

	return (
		<div
			className={clsx(props.rowRootClass ?? classes.root, {
				[classes.manyItems]: manyItems
			})}
		>
			{items.map((item: IDocumentDetailsItem, index: number) => {
				const controlledBy = item.controlledBy ? `${item.controlledBy}-section` : 'self';
				return (
					<div
						key={index}
						className={props.rowItemClass ?? classes.rowItem}
						data-test-id={`${item.testId || 'item'}-container`}
					>
						<div
							className={props.titleClass ?? classes.title}
							data-controlled-by={controlledBy}
							data-test-id={`${item.testId || 'item'}-key`}
						>
							{item.title && `${item.title}:`}
						</div>
						<div
							className={props.valueClass ?? classes.value}
							data-controlled-by={controlledBy}
							data-test-id={`${item.testId || 'item'}-value`}
						>
							{item.linkValue ? (
								<a target="_new" href={item.value as string}>
									{item.value}
								</a>
							) : props.useHtml ? (
								<span dangerouslySetInnerHTML={{ __html: item.value as string }} />
							) : (
								item.value
							)}
						</div>
						{index !== items.length - 1 && <Divider />}
					</div>
				);
			})}
		</div>
	);
};

export default DocumentDetailsRow;
